import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import UserService from "../services/UserService";
import firebase from "../services/FirebaseService";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../assets/style/admin.css";
import { faComment, faDollarSign, faFileAlt } from "@fortawesome/free-solid-svg-icons";

const Options = () => (
	<section id="admin-nav">
		<Link to="/admin/requests">
			<div>
				<h1><FontAwesomeIcon icon={faFileAlt} /></h1>
			</div>
			<div>
				<h2>Mentorship Applications</h2>
				<p>Take a look at new applications and delete any accepted ones!</p>
			</div>
		</Link>
		<Link to="/admin/chats">
			<div>
				<h1><FontAwesomeIcon icon={faComment} /></h1>
			</div>
			<div>
				<h2>Live Chats</h2>
				<p>Answer live chats!</p>
			</div>
		</Link>
		<Link to="/admin/donations">
			<div>
				<h1><FontAwesomeIcon icon={faDollarSign} /></h1>
			</div>
			<div>
				<h2>Donation Requests</h2>
				<p>Check who wants to donate a plan for a child.</p>
			</div>
		</Link>
	</section>
);

const AdminPage = () => {
	
	const userService = new UserService();

	const [ privileged, setPriviledged ] = useState(0);

	firebase.auth().onAuthStateChanged(async user => {
		
		if(user) {
			const isAdmin = await userService.isUserAdmin(user.uid);

			isAdmin ? setPriviledged(1) : setPriviledged(2);
		}
		else {
			setPriviledged(2);
		}

	});

	return (
		<>
			{ privileged === 2 && <Redirect to="/" /> }
			{ privileged === 1 && 
				<>
					<Navbar />
					<Options />
					<Footer />
				</>
			}
		</>
	)

};

export default AdminPage;